module.exports = __webpack_public_path__ + "94d78004abaaf465609e6dec1cc05f9b.png";